
import { map } from 'rxjs/operators';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormsModule, FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomerService } from '../../customer/customer.service';
import { CustomerStatus, Customer, State, CustomerType, CustomerTitle, PreferredContact, CustomerCFModel, Vendor, CustomerMultipleLogin } from '../../customer/customer.models';
import { SharedService } from '../.././shared/shared.service';
import { FPMessage, Severities, RoleAccess, PageKey } from '../.././shared/shared.model';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem } from 'primeng/primeng';
import { BaseComponent } from '../.././shared/base.component';
import { CapitalizeFirstPipe } from '../.././shared/pipes/custom-pipes.pipe';
import { emailValidator, compareValidator } from '../.././shared/custom-validators/custom-validator.directive';
import { CustomFieldsUpdater, CustomFieldUpdaterService } from '../.././shared/custom-fields/custom-fields-updater.service';
import { CustomFieldsConfiguration } from '../.././shared/custom-fields/custom-fields-models';
import { Type, Operator } from '../.././shared/custom-validators/custom-validator.model';
import { LoaderService } from '../.././shared/loader.service';
import { API_Settings_ERPeSales } from '../.././core/app-config';
import { Email } from 'app/layout/work-order/work-order-models';
@Component({
    selector: 'customer-multiplelogin-edit',
    templateUrl: 'customer-multiplelogin-edit.component.html'
})
export class CustomerMultipleLoginEditComponent extends BaseComponent implements OnInit {

    @Input() customerId: number;
    @Input() header: string;
    @Input() rights: RoleAccess = new RoleAccess;
    @Input() CustomerMultipleLoginEnable: number;
    @Output() dismissmultiplelogin = new EventEmitter();

    CustomerEmailList: CustomerMultipleLogin[]=[];
    MultipleLoginId: number=0;
    frmCustomer: FormGroup;
    submitted: boolean = false;
    message: FPMessage;
    loader: boolean = false;
    isEdit: boolean = true;
    isAdd: boolean = true;
    companyId: number;
    EnableCustomerMasterPassword: boolean = false;
    complexval: string[] = [];
    passwordcomplexity: string[] = [];
    isPasswordComplexityPopup: boolean = false;
    ispasswordcomplex: boolean = false;
    oldPassword: string;
    crights: RoleAccess = new RoleAccess;
    IsEnablePrefVendor: boolean = false;
    vendor: Vendor[] = [];
    IsFormsEnable:boolean = false;

    constructor(protected sharedService: SharedService, private loaderService: LoaderService, private updater: CustomFieldUpdaterService, private customerService: CustomerService, private router: Router, fb: FormBuilder, private formBuilder: FormBuilder, protected translateService: TranslateService) {
        super(sharedService, translateService);

        this.companyId = super.globalInfo().CompanyId;

        this.frmCustomer = this.formBuilder.group({
            Email: ['', Validators.compose([Validators.required, emailValidator])],
            Password: ['', Validators.compose([Validators.required,compareValidator('Confpassword', Type.string, Operator.Equal, null, true)])],
            Confpassword: ['', Validators.compose([Validators.required,compareValidator('Password', Type.string, Operator.Equal)])],
        }
            ,
            {
                validator: Validators.compose([onblurchange(), validateEmailRequired()])
            }
        );
    }



    ngOnInit() {
        this.getChildPriviliges();
        this.getCustomerMultipleLoginDetails();
        this.customerService.getEnableCustomerMasterPassword(super.globalInfo().CompanyId).subscribe(res => {
            debugger
            this.EnableCustomerMasterPassword = res
            if (res == 1) {
                
                this.EnableCustomerMasterPassword = true;

            }
            else {

                this.EnableCustomerMasterPassword = false;
              
            }
        })

    }
    getChildPriviliges() {
        this.loaderService.show();
        this.sharedService.getChildPrivileges(super.globalInfo().CompanyId, super.globalInfo().LoginId,
            PageKey.Customer,
            PageKey.Customer_CreateCustomer)
            .subscribe(s => {
                s.map(m => {
                    this.crights = m
                    console.log('log' + this.rights);
                })
                if (this.crights.ViewRights != 1) {
                    this.router.navigate(['/account/accessdenied']);
                }
                this.loaderService.hide();
            });
    }
    
    getCustomerMultipleLoginDetails()
    {
        this.loaderService.show();

        if (this.customerId != null && this.customerId != 0) {

            this.isEdit = (this.customerId != null && this.customerId > 0 && this.rights.EditRights == 1) ? true : false;

            this.customerService.getCustomerMultipleLogin(super.globalInfo().CompanyId, this.customerId).subscribe(
                (value) => {
                    this.CustomerEmailList = value;

                    if(this.CustomerMultipleLoginEnable <= this.CustomerEmailList.length)
                    {
                        this.IsFormsEnable = false;
                    }
                    else
                    {
                        this.IsFormsEnable = true;
                    }
                    this.loaderService.hide();
                });
        }
        else {
            this.loaderService.show();

            setTimeout(() => {
                if (typeof this.crights.AddRights != "undefined") {
                    this.isEdit = (this.crights.AddRights == 1) ? true : false;
                    // this.isAdd = (this.crights.AddRights == 1) ? true : false;
                }
                this.loaderService.hide();

            }, 1000);

        }
    }

    saveCustomer(customer: CustomerMultipleLogin, formValid: boolean) {
        var npassword = customer.Password;
        this.submitted = true;

        if (formValid) {

            this.loader = true;
            console.log("form valid");
            customer.CompanyId = super.globalInfo().CompanyId;
            customer.Email = customer.Email.trim();

            if (this.customerId > 0) {
                customer.Password = npassword;
                // customer.Password = this.oldPassword == 'undefined' ? '' : this.oldPassword;
                customer.CustomerId = this.customerId;
                customer.LoginId = super.globalInfo().LoginId;
                customer.MultipleLoginId = this.MultipleLoginId;

                this.customerService.InsertMultipleLoginCustomer(customer).subscribe(s => {
                    this.message = s.Message;
                    if (s.Message.Severity == Severities.success) {

                        this.frmCustomer.patchValue({
                            Email: '',
                            Password: '',
                            Confpassword: ''
                        });
                        this.oldPassword = '';
                        this.MultipleLoginId = 0;
                        this.close(true);
                    }
                     else this.close(false);
                });
                
            } else {
                
            }
        }
    }
    
    close(success?: boolean) {

        this.loader = false;
        if (success || success == false) {
            if (this.message.MessageCode == "1001" || this.message.MessageCode == "1002") {
                this.sharedService.notification.emit({
                    severity: Severities[this.message.Severity],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                    detail: this.translate.instant('CUSTOMER') + " " + this.translate.instant(this.message.MessageCode)
                });
            }
            else {
                this.sharedService.notification.emit({
                    severity: Severities[this.message.Severity],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                    detail: this.translate.instant(this.message.MessageCode)
                });
                return;
            }
            this.getCustomerMultipleLoginDetails();
        }
        else if (success == null || success == undefined)
            this.dismissmultiplelogin.emit(null);
    }

    closePassComplex() {
        this.isPasswordComplexityPopup = false;
    }
    PassComplex() {
        var password = this.frmCustomer.controls["Password"].value;
        if (password) {
            this.loaderService.show();
            this.customerService.getPaswordComplexity(super.globalInfo().CompanyId, password).subscribe(passcomplex => {
                this.complexval = passcomplex;
                this.loaderService.hide();
                if (passcomplex[0] == 'True') {
                    this.ispasswordcomplex = false;
                }
                else {
                    this.ispasswordcomplex = true;
                }
            }, err => { this.loaderService.hide(); });
            onblurchange();
        }
    }
    Complexity() {
        this.passwordcomplexity = this.complexval;
        this.isPasswordComplexityPopup = true;
    }
    editCustomerMultipleEmail(val:CustomerMultipleLogin)
    {
        this.frmCustomer.patchValue({
                    Email: val.Email,
                    Password: val.Password,
                    Confpassword: val.Password
        });
        this.oldPassword = val.Password;
        this.MultipleLoginId = val.MultipleLoginId;

    }
}

//Page specific custom validator
function onblurchange() {
    return (formGroup: FormGroup): { [key: string]: any } => {
        let Password = formGroup.controls['Password'];
        let Email = formGroup.controls['Email'];
        let r = ((Password.value != '') && Email.value == '') ? { 'invalidEmail': true } : null;
        return r;
    };
}
function validateEmailRequired() {
    return (formGroup: FormGroup): { [key: string]: any } => {

        let Password = formGroup.controls['Password'];
        let Email = formGroup.controls['Email'];
        let r = ((Password.value != '') && Email.value == '') ? { 'emailRequired': true } : null;
        return r;
    };
}


